module.exports = __webpack_public_path__ + "img/12_jobs-and-careers.e91ad845.png";